/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import {
    object, string, shape, bool, array,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Helmet from 'react-helmet';
import { uid } from 'react-uid';
import QaList from './Partials/QaList';

class QaListContainer extends PureComponent {
    setlayout(viewAllData, popularDescription, categorizeDescription, category, defaultCategoryValue) {
        const { data, identifyWidthObj } = this.props;
        const presentation = data.presentation || {};
        const layoutTitle = data.title || '';
        const categorize = presentation.categorize || false;
        const showPopular = presentation.show_popular || false;
        const accordion = presentation.accordion || false;
        const setLayout = [];
        if (showPopular) {
            setLayout.push(
                <Grid item xs={12} key={uid(`Popular-${layoutTitle}`)}>
                    <QaList
                        layoutTitle={`Popular ${layoutTitle}`}
                        layoutDescription={popularDescription}
                        identifyWidthObj={identifyWidthObj}
                        isCategory={false}
                        accordion={accordion}
                    />
                </Grid>,
            );
        }
        if (!categorize) {
            setLayout.push(
                <Grid item xs={12} key={uid(`Non-Categorize-${layoutTitle}`)}>
                    <QaList
                        layoutTitle={layoutTitle}
                        layoutDescription={viewAllData}
                        identifyWidthObj={identifyWidthObj}
                        isCategory={false}
                        accordion={accordion}
                    />
                </Grid>,
            );
        } else {
            setLayout.push(
                <Grid item xs={12} key={uid(`Categorize-${layoutTitle}`)}>
                    <QaList
                        layoutTitle={`${layoutTitle} by Category`}
                        layoutDescription={categorizeDescription}
                        categoryDescription={category}
                        identifyWidthObj={identifyWidthObj}
                        defaultCategoryValue={defaultCategoryValue}
                        isCategory
                        accordion={accordion}
                    />
                </Grid>,
            );
        }
        return setLayout;
    }

    render() {
        const { data, faqSchema } = this.props;
        if (!data) return null;
        const categoryDescription = [];
        const popularDescription = [];
        const layoutDescription = [];
        const viewAllData = [];
        const categories = data.categories || [];
        const faqArray = [];
        let defaultCategoryValue = '';
        if (categories?.length > 0) {
            categories.forEach((categoryItem, index) => {
                const category = categoryItem.category || {};
                const categoryTitle = category.category_title || '';
                const categoryDetail = category.entries || [];
                const categoryValue = categoryTitle.split(' ').join('').toLowerCase();
                const faqDetail = {
                    key: categoryValue,
                    value: [],
                };
                if (index === 0) {
                    defaultCategoryValue = categoryValue;
                }
                categoryDescription.push({
                    label: categoryTitle,
                    value: categoryValue,
                });
                if (categoryDetail && categoryDetail.length > 0) {
                    categoryDetail.forEach((faqItem) => {
                        const entry = { ...faqItem }?.entry;
                        const isPopular = { ...entry }?.popular;
                        if (isPopular) {
                            popularDescription.push(entry);
                        }
                        faqDetail.value.push(entry);
                        faqArray.push(entry);
                    });
                }
                layoutDescription.push(faqDetail);
                if (faqDetail?.value && faqDetail?.value.length > 0) {
                    viewAllData.push(...faqDetail.value);
                }
            });
            categoryDescription.push({
                label: 'View All',
                value: 'viewall',
            });
            layoutDescription.push({
                key: 'viewall',
                value: viewAllData,
            });
        }
        return (
            <>
                {faqSchema && (
                    <Helmet>
                        <script type="application/ld+json">
                            {`{
                            "@context": "https://schema.org",
                            "@type": "FAQPage",
                            "mainEntity": [${faqArray && faqArray.map((faqData) => (`{"@type": "Question","name": "${faqData.question}","acceptedAnswer": {"@type": "Answer","text": "${faqData.answer}"}}`))}]}`}
                        </script>
                    </Helmet>
                )}
                {this.setlayout(viewAllData, popularDescription, layoutDescription, categoryDescription, defaultCategoryValue)}
            </>
        );
    }
}

QaListContainer.propTypes = {
    faqSchema: bool,
    data: shape({
        locale: string.isRequired,
        categories: array,
        presentation: object,
        title: string.isRequired,
        uid: string.isRequired,
    }).isRequired,
    identifyWidthObj: shape({
        isMobile: bool.isRequired,
        isDesktop: bool.isRequired,
    }).isRequired,
};

QaListContainer.defaultProps = {
    faqSchema: false,
};

export default QaListContainer;
